import {
  addSignalAttribute,
  init,
  reportError as dash0ReportError,
} from '@dash0/sdk-web';

import type { ErrorReporter } from '@xing-com/crate-xinglet';

import type { Dash0InitOptions } from './types';

export function setupDash0({
  serviceName = 'crate-app',
  endpoint,
  serviceVersion,
  ...options
}: Partial<Dash0InitOptions> = {}): ErrorReporter {
  const environment = {
    'www.xing.com': 'production' as const,
    'preview.xing.com': 'preview' as const,
    'brewery.xing.io': 'brewery-production' as const,
    'preview.brewery.xing.io': 'brewery-production' as const,
    'lebenslauf.com': 'lebenslauf-production' as const,
    'preview.lebenslauf.com': 'lebenslauf.preview' as const,
    'anschreiben.com': 'anschreiben-production' as const,
    'preview.anschreiben.com': 'anschreiben.preview' as const,
  }[document.location.hostname];

  if (!environment || !serviceName || !endpoint) {
    return function ignoreError() {
      //
    };
  }

  init({
    serviceName,
    endpoint,
    environment,
    serviceVersion,
    ...options,
  });

  addSignalAttribute('cost_center', '11131');
  addSignalAttribute('application', 'crate');

  return function reportError(error, context) {
    dash0ReportError(error, context);
  };
}
